module.exports = __webpack_public_path__ + "static/img/getimage.a7d539c.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/getimage.png
// module id = nYoq
// module chunks = 79